'use strict';

import controller from './cambiar.controller';
import template from './cambiar.html';

const CambiarComponent = {
    bindings: {},
    controller,
    template
};

export default CambiarComponent;


// WEBPACK FOOTER //
// ./src/app/components/admin/login/cambiar/cambiar.component.js